import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Breadcrumbs from "../../../components/Breadcrumbs";
import SampleInformation from "./SampleInformation";
import Estimate from "./Estimate";
import BillingInformation from "./BillingInformation";
import Verification from "./Verification";
import Confirmation from "./Confirmation";
import ProgressBar from "../../../components/forms/ProgressBar";
import {
  editWpsRow,
  initializeWpsTableData,
  wpsNextStep,
  wpsPrevStep,
  resetWpsState,
  setWpsComments,
  setWpsCompany,
  setWpsDropboxId,
  setWpsDropboxLocation,
  setWpsDropoffDate,
  setWpsEmail,
  setWpsFirstName,
  setWpsLastName,
  setWpsPhone,
  setWpsSampleAmount,
  setWpsShippingOption,
} from "../../../store";
import { useLocation, useNavigate } from "react-router-dom";

import { url } from "../../../configlink";

const WpsForm = () => {
  const page = useSelector((state) => state.wpsForm.page);
  const dispatch = useDispatch();
  const dropboxlocations = useSelector((state) => state.user.dropbox);


	let nav = useNavigate() 
	let wpsCorp = useSelector((state) => state.user.wpsExcludeCorp)  

	useEffect(() => {
		wpsValidity()
	}, [wpsCorp])
 
	function wpsValidity(){ 
		if(wpsCorp === true){
			nav('/dashboard')
		}
           
	}

  const handlePrevPage = () => {
    dispatch(wpsPrevStep());
  };
  const handleNextPage = () => {
    dispatch(wpsNextStep());
  };

  // const token = localStorage.getItem("token");

  let loc = useLocation();

  let excelHeaders = ["id", "sampleID", "sampleType", "targetType", "targetSize", "dataAnalysis"];

  useEffect(() => {
    if (loc.search) {
      dispatch(resetWpsState());
      let orderNum = loc.search.split("=")[1];
      try {
        fetch(`${url}/api/orderForm/getUserOrdersDraftData?orderNumber=${orderNum}`, {
          method: 'GET',
          credentials: 'include',
          // headers: {
          //   Authorization: `Bearer ${token}`,
          // },
        })
          .then((res) => res.json())
          .then((data) => {
            // console.log("fetched data", data.result);
            let result = data.result[0];
            //page0

            if (result.NumOfRxns) {
              dispatch(setWpsSampleAmount(result.NumOfRxns));
              dispatch(initializeWpsTableData(result.NumOfRxns));
            }
            if (result.OrderDetails) {
              let orderJson = JSON.parse(result.OrderDetails);
              // console.log("OJ", orderJson);
              for (let i = 0; i < orderJson.length; i++) {
                let index = i;
                for (let j = 0; j < excelHeaders.length; j++) {
                  let value = Object.values(orderJson[i])[j];
                  let property = Object.keys(orderJson[i])[j];

                  dispatch(editWpsRow({ index, value, property }));
                }
              }
            }
            if (result.AdditionalComments) {
              dispatch(setWpsComments(result.AdditionalComments));
            }
            if (result.BillingUser) {
              let info = JSON.parse(result.BillingUser);
              // console.log(info);
              if (info) {
                dispatch(setWpsFirstName(info.firstName));
                dispatch(setWpsLastName(info.lastName));
                dispatch(setWpsCompany(info.company));
                dispatch(setWpsPhone(info.phone));
                dispatch(setWpsEmail(info.email));
              }
            }
            if (result.ShippingOption) {
              dispatch(setWpsShippingOption(result.ShippingOption));
            }
            // need to work on getting ID right, for now setting it to NY
            if (result.ShippingOption === "Dropbox" && result.DropBoxId) {
              let dropboxOption = dropboxlocations.filter(x => x.dropBoxId === result.DropBoxId)
              dispatch(setWpsDropboxLocation({ label: dropboxOption[0].building }));
              dispatch(setWpsDropboxId(result.DropBoxId));
            }
            if (result.ShippingOption === "Dropbox" && result.DropBoxDate) {
              dispatch(setWpsDropoffDate(result.DropBoxDate.split("T")[0]));
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } catch (err) {
        console.error(err);
      }
    }
  }, []);

  const PageDisplay = () => {
    switch (page) {
      case 0:
        return (
          <SampleInformation
            page={page}
            handleNextPage={handleNextPage}
            progress={<ProgressBar page={page} steps={5} />}
          />
        );
      case 1:
        return (
          <Estimate
            page={page}
            handleNextPage={handleNextPage}
            handlePrevPage={handlePrevPage}
            progress={<ProgressBar page={page} steps={5} />}
          />
        );
      case 2:
        return (
          <BillingInformation
            page={page}
            handleNextPage={handleNextPage}
            handlePrevPage={handlePrevPage}
            progress={<ProgressBar page={page} steps={5} />}
          />
        );
      case 3:
        return (
          <Verification
            page={page}
            handleNextPage={handleNextPage}
            handlePrevPage={handlePrevPage}
            progress={<ProgressBar page={page} steps={5} />}
          />
        );
      case 4:
        return <Confirmation page={page} progress={<ProgressBar page={page} steps={5} />} />;
      default:
        break;
    }
  };

  return (
    <>
      <Breadcrumbs title='Whole Plasmid Sequencing' url='wps' />
      <PageDisplay />
    </>
  );
};

export default WpsForm;
